const useAxios = {
  install(Vue, service){
    Object.defineProperties(Vue.prototype, {
      $http:{
        get(){
          return service
        }
      }
})
  }
}
export default useAxios


// WEBPACK FOOTER //
// ./src/common/request/useAxios.js